import SlidingCardGridBaseComponent from "segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/sliding-card-grid-base-component";

const SlidingCardGridMobileComponent = ({ cardsToShow, isFullScreen, ...rest }) => (
  <SlidingCardGridBaseComponent {...rest} isFullScreen cardsToShow={1.2} />
);
export default SlidingCardGridMobileComponent;
